import { Box, Icon, Text } from "@modernatx-internal/component-library";
import { findKey, uniq } from "lodash";

import { useExperience } from "@/context/ExperienceContext";
import { useFinder } from "@/finder/hooks/V2/useFinder";

export const ProductAvailability = ({ productsAtLocation }: { productsAtLocation: string[] }) => {
  const { products, productsFromResults, selectedVaccines, vaccineDropdownOptions } = useFinder();
  const { country } = useExperience();

  if (
    !productsAtLocation ||
    productsAtLocation.length < 1 ||
    !products ||
    !vaccineDropdownOptions ||
    vaccineDropdownOptions?.length === 0
  ) {
    return null;
  }

  const relevantVaccines = vaccineDropdownOptions.filter((option) => {
    const productsForVaccine = products[option.value];
    return (
      selectedVaccines?.includes(option.value) ||
      Boolean(
        productsForVaccine &&
        productsFromResults.some((product) => productsForVaccine.includes(product))
      )
    );
  });

  const vaccinesAtLocation = uniq(
    productsAtLocation
      .map((product) => {
        return findKey(products, (productList) => productList?.includes(product));
      })
      .filter(Boolean)
  );

  // Create availability items for each product option
  const items = relevantVaccines.map((vaccineOption) => {
    const isAvailable = vaccinesAtLocation.includes(vaccineOption.value);

    return (
      <Box
        key={`${vaccineOption.value}-availability`}
        as="li"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "spacing-3",
          mb: "spacing-2"
        }}
      >
        <Icon
          icon={isAvailable ? "check-circle" : "x-circle"}
          color={isAvailable ? "color-system-green-600" : "color-system-red-800"}
          size="xs"
          weight={isAvailable ? "filled" : "regular"}
        />
        <Text
          variant={isAvailable ? "body-2-medium" : "body-2-regular"}
          sx={{ color: isAvailable ? "text-default" : "text-incidental" }}
        >
          {vaccineOption.label}
        </Text>
      </Box>
    );
  });

  if (items.length === 0) {
    return null;
  }

  return (
    <Box as="ul" sx={{ listStyle: "none" }}>
      {country === "jp" && (
        <Box sx={{ pb: "spacing-3" }}>
          <Text variant="body-2-medium">モデルナ新型コロナワクチン接種可能年齢</Text>
        </Box>
      )}
      {items}
    </Box>
  );
};
